import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/licenses',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/LicensesContainer',
      './modules/Licenses'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Licenses = require('./containers/LicensesContainer').default
      const actions = require('./modules/Licenses')
      const reducer = require('./modules/Licenses').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'licenses', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, Licenses)

    /* Webpack named bundle   */
    }, 'Licenses')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Licenses/index.js